<template>
  <b-navbar b-navbar type="light" variant="light" toggleable="md" style="margin-top: 5rem;">
    <b-navbar-nav class="ml-auto">
      <b-nav-item :to="{ name: 'datenschutz' }">Datenschutzerklärung</b-nav-item>
      <b-nav-item :to="{ name: 'impressum' }">Impressum</b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  name: 'FooterNavbar'
};
</script>